import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-form" }
const _hoisted_3 = { class: "text-center mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = {
  key: 1,
  class: "text-center space-y-3"
}
const _hoisted_6 = { class: "form-password" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "mt-2 text-center text-sm text-red"
}
const _hoisted_10 = { class: "form-password" }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = ["disabled", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_LoginStep = _resolveComponent("LoginStep")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        (_ctx.currentStep === _ctx.enumLoginSteps.ChooseNumber)
          ? (_openBlock(), _createBlock(_component_LoginStep, {
              key: 0,
              title: ['Подтвердите действие']
            }, {
              action: _withCtx(() => [
                _createElementVNode("p", _hoisted_3, [
                  _createTextVNode(" Вы хотели войти под номером " + _toDisplayString(_ctx.phoneFromMain) + ", но в Яндекс указан номер " + _toDisplayString(_ctx.phoneFromYandex) + ". ", 1),
                  _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                  _cache[10] || (_cache[10] = _createTextVNode("Продолжить регистрацию? ", -1))
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_ButtonComponent, {
                    class: "form-button mb-6",
                    font: "normal",
                    rounded: "md",
                    color: "primary",
                    onClickAction: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({ name: 'LoginPage' }))),
                    title: "Вернуться к авторизации"
                  }),
                  _createVNode(_component_ButtonComponent, {
                    class: "form-button mb-3",
                    font: "normal",
                    rounded: "md",
                    color: "greyLight",
                    onClickAction: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentStep = _ctx.enumLoginSteps.CreatePass)),
                    title: "Продолжить"
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.currentStep === _ctx.enumLoginSteps.AuthYandex)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!_ctx.hasError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("p", { class: "text-lg" }, "Еще немного...", -1),
                    _createElementVNode("p", null, "Завершаем авторизацию", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-lg" }, "Произошла ошибка с авторизацией через Яндекс", -1)),
                    _createElementVNode("p", null, _toDisplayString(_ctx.describeError), 1),
                    _cache[13] || (_cache[13] = _createElementVNode("p", null, "Попробуйте еще раз или войдите через другой метод", -1)),
                    _createVNode(_component_ButtonComponent, {
                      title: "К авторизации",
                      onClickAction: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.replace('/')))
                    })
                  ]))
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.currentStep === _ctx.enumLoginSteps.CreatePass)
          ? (_openBlock(), _createBlock(_component_LoginStep, {
              key: 2,
              title: ['Придумайте свой пароль'],
              subtitle: "Это НЕ СМС и НЕ ЗВОНОК",
              attention: 
              _ctx.passwordError && _ctx.passwordError.length ? _ctx.passwordError : null
            
            }, {
              action: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                      return _createElementVNode("input", {
                        key: i,
                        class: _normalizeClass([{ active: _ctx.password[i - 1] }, "input-box focus:border focus:border-yellow-200"]),
                        onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.keyDownEvent('password')), ["delete"])),
                        onInput: _cache[4] || (_cache[4] = ($event: any) => (
                        _ctx.inputPasswordEvent('password', $event.target.value)
                      )),
                        ref_for: true,
                        ref: "input",
                        type: "password",
                        value: _ctx.password[i - 1],
                        onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onFocusPassword('password'))),
                        inputmode: "numeric",
                        pattern: "[0-9]*",
                        autocomplete: "off",
                        maxlength: "1"
                      }, null, 42, _hoisted_8)
                    }), 64))
                  ]),
                  _createVNode(_component_ButtonComponent, {
                    disabled: !_ctx.isCreateContinueEnabled,
                    class: "form-button mb-6",
                    loading: _ctx.hasRequest,
                    font: "normal",
                    type: "submit",
                    rounded: "md",
                    onClickAction: _ctx.goToRepeatPass,
                    color: _ctx.isCreateContinueEnabled ? 'primary' : 'greyLight',
                    title: "Продолжить"
                  }, null, 8, ["disabled", "loading", "onClickAction", "color"])
                ]),
                (_ctx.passwordWeakHint)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.passwordWeakHint), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["attention"]))
          : _createCommentVNode("", true),
        (_ctx.currentStep === _ctx.enumLoginSteps.RepeatPass)
          ? (_openBlock(), _createBlock(_component_LoginStep, {
              key: 3,
              title: ['Повторите пароль'],
              attention: 
              !_ctx.passwordRepeat.length && _ctx.passwordRepeatError
                ? _ctx.passwordRepeatError
                : null
            
            }, {
              action: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                      return _createElementVNode("input", {
                        key: i,
                        class: _normalizeClass([{ active: _ctx.passwordRepeat[i - 1] }, "input-box focus:border focus:border-yellow-200"]),
                        ref_for: true,
                        ref: "input",
                        onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.keyDownEvent('passwordRepeat')), ["delete"])),
                        onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onFocusPassword('passwordRepeat'))),
                        disabled: _ctx.hasRequest,
                        onInput: _cache[8] || (_cache[8] = ($event: any) => (
                        _ctx.inputPasswordEvent(
                          'passwordRepeat',
                          $event.target.value,
                        )
                      )),
                        value: _ctx.passwordRepeat[i - 1],
                        inputmode: "numeric",
                        pattern: "[0-9]*",
                        type: "password",
                        autocomplete: "off",
                        maxlength: "1"
                      }, null, 42, _hoisted_12)
                    }), 64))
                  ]),
                  _createVNode(_component_ButtonComponent, {
                    disabled: 
                    _ctx.passwordRepeat.length < 5 || _ctx.passwordRepeat !== _ctx.password
                  ,
                    class: "form-button",
                    font: "normal",
                    type: "submit",
                    loading: _ctx.hasRequest,
                    rounded: "md",
                    color: _ctx.passwordRepeat.length === 5 ? 'primary' : 'greyLight',
                    title: "Продолжить",
                    onClickAction: _ctx.activateUser
                  }, null, 8, ["disabled", "loading", "color", "onClickAction"])
                ])
              ]),
              _: 1
            }, 8, ["attention"]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_auto_animate]
      ])
    ])
  ]))
}